"use client";
import * as React from "react";
import { DataTable, type Column } from "../DataTable";
import { PageHeader, StatCard, Card2 } from "../ModuleHelpers";
import { useERP, formatBDT, formatNum } from "@/lib/erp/store";
import { Store } from "lucide-react";

export function DMSModule() {
  const erp = useERP();
  const distributors = erp.customers.filter(c => c.type === "Distributor").map((c, i) => ({
    id: c.id, code: c.code, name: c.name, zone: c.zone,
    creditUtil: Math.round((c.outstanding / c.creditLimit) * 100),
    orders: Math.floor(Math.random() * 30) + 5,
    score: 90 - i * 4,
    outstanding: c.outstanding,
  }));
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Distribution Management" desc="Distributor scorecards, performance and network optimization." icon={Store} />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard label="Distributors" value={formatNum(distributors.length)} />
        <StatCard label="Avg Score" value={`${Math.round(distributors.reduce((s, d) => s + d.score, 0) / Math.max(1, distributors.length))}`} tone="text-primary" />
        <StatCard label="Total Outstanding" value={formatBDT(distributors.reduce((s, d) => s + d.outstanding, 0))} tone="text-destructive" />
        <StatCard label="Avg Credit Util" value={`${Math.round(distributors.reduce((s, d) => s + d.creditUtil, 0) / Math.max(1, distributors.length))}%`} />
      </div>
      <Card2 title="Distributor Scorecard">
        <DataTable
          columns={[
            { key: "code", header: "Code", sortable: true, render: r => <span className="font-mono text-xs">{r.code}</span> },
            { key: "name", header: "Distributor", sortable: true },
            { key: "zone", header: "Zone" },
            { key: "orders", header: "Orders (30d)", align: "right", sortable: true },
            { key: "creditUtil", header: "Credit Util %", align: "right", render: r => <span className={r.creditUtil > 80 ? "text-destructive font-medium" : ""}>{r.creditUtil}%</span> },
            { key: "score", header: "Score", align: "right", sortable: true, render: r => <span className={`inline-flex rounded-md px-2 py-0.5 text-xs ${r.score >= 85 ? "bg-primary text-primary-foreground" : "bg-secondary"}`}>{r.score}</span> },
          ] as Column<typeof distributors[number]>[]}
          data={distributors}
          rowKey={r => r.id}
          searchKeys={["code", "name", "zone"]}
        />
      </Card2>
    </div>
  );
}
